<template>
    <div class="NavigationIcon">
       <transition-group
                v-if="step.cards.length > 1"
                class="step-navigator"
                :class="{dragging: stepNavigatorItemDragging}"
                name="transition-card"
            >
                <div
                    key="first-drop-space"
                    class="step-navigator-drop-zone"
                    @dragenter="onDragEnterNav"
                    @dragleave="onDragLeaveNav"
                    @dragover.prevent
                    @drop="onDropNav($event,null)"
                >
                    <v-icon small @dragenter="onDragEnterNav">mdi-plus-circle-outline</v-icon>
                </div>
                <template v-for="card in step.cards" >
                    <div
                        :key="card.code+'-icon'"
                        class="step-navigator-item "
                        :class="{active: card.code === activeCardCode}"
                        @click="scrollToCard(card)"
                        :draggable="true"
                        @dragstart="startDragNav($event, card.code)"
                        @dragend="endDragNav"
                    >
                        <img
                            :src="`/img/scenario/card/${card.code === activeCardCode ? 'white' : 'normal'}/${card.card_type_id}.svg`"
                            alt="" draggable="false"
                        >
                    </div>
                    <div
                        :key="card.code+'-icon-drop'"
                        class="step-navigator-drop-zone"
                        @dragenter="onDragEnterNav"
                        @dragleave="onDragLeaveNav"
                        @dragover.prevent
                        @drop="onDropNav($event,card)"
                    >
                        <v-icon small @dragenter="onDragEnterNav">mdi-plus-circle-outline</v-icon>
                    </div>
                </template>
            </transition-group>
    </div>
</template>

<script>

import { mapState } from 'vuex'
export default {
    name: 'NavigationIcon',
    data () {
        return {
            stepNavigatorItemDragging: false
        }
    },
    computed: {
        ...mapState({
            step: state => state.scenario.activeStep,
            activeCardCode: state => state.scenario.activeCardCode,
            shouldUpdateGraph: state => state.scenario.shouldUpdateGraph
        })
    },
    methods: {
        scrollToCard (card) {
            this.$store.dispatch(this.$at.scenario.ACTIVE_DATA, {
                activeCardCode: card.code
            })
            this.$emit('scroll-to-card', card.code)
        },
        startDragNav (event, cardCode) {
            this.stepNavigatorItemDragging = true
            event.dataTransfer.setData('moveCardCode', cardCode)
        },
        endDragNav () {
            this.stepNavigatorItemDragging = false
        },
        onDragEnterNav (event) {
            if (event.target.classList.contains('step-navigator-drop-zone')) {
                event.target.classList.add('active')
            } else {
                event.target.parentElement.classList.add('active')
            }
        },
        onDragLeaveNav (event) {
            if (event.target.classList.contains('step-navigator-drop-zone')) {
                event.target.classList.remove('active')
            } else {
                event.target.parentElement.classList.remove('active')
            }
        },
        onDropNav (event, dropCard) {
            this.onDragLeaveNav(event)
            let dragCardCode = event.dataTransfer.getData('moveCardCode')
            if (dragCardCode) {
                let dragCard = this.$store.state.scenario.mapCodeToCard[dragCardCode]
                if (dropCard && dropCard.code === dragCard.code) {
                    return
                }
                let cardList = this.$store.state.scenario.mapCodeToStep[dragCard.step_code].cards
                let index = cardList.indexOf(dragCard)
                cardList.splice(index, 1)
                if (dropCard) {
                    index = cardList.indexOf(dropCard)
                    index++
                } else {
                    index = 0
                }
                cardList.splice(index, 0, dragCard)
                cardList.forEach((card, i) => {
                    card.position = i
                })
                this.$store.dispatch(this.$at.scenario.POSITION_CARD, {
                    stepCode: dragCard.step_code,
                    cardCodeList: cardList.map(card => card.code)
                })
            } else {
                let card = {
                    step_code: this.step.code,
                    card_type_id: event.dataTransfer.getData('addCardType'),
                    position: dropCard ? dropCard.position + 1 : 0
                }
                this.$store.dispatch(this.$at.scenario.CREATE_CARD, card)
            }
        }
    },
    watch: {
        shouldUpdateGraph () {
            this.$forceUpdate()
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/fci-var";
$borderColor: #D0D4E2;
.step-navigator {
    border-bottom: 1px solid $borderColor;
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .step-navigator-item {
        padding: 0 5px;
        height: 25px;
        display: flex;
        align-items: center;

        &:hover {
            background: #ccc;
        }

        &.active {
            background: $primary1;
        }

        img {
            height: 15px;
            display: block;
        }
    }

    .step-navigator-drop-zone {
        height: 25px;
        padding: 0;
        border: 1px dashed $primary1;
        opacity: 0;
        width: 0;
        overflow: hidden;
        transition: $transition;

        i {
            color: $primary1;
            transform: scale(0.7);
            pointer-events: none;
        }

        &.active {
            background: $primary1;

            i {
                color: #fff;
            }
        }
    }

    &.dragging {
        .step-navigator-drop-zone {
            width: 18px;
            opacity: 1;
        }
    }
}
.transition-card-move {
    transition: transform 0.6s;
}

</style>
